export default __webpack_public_path__ + "static/media/89_photo.d05688f5.jpg";